import { Icon as GIcon } from "@gwrk/g-components/enums";

export const Icon = {
  ...GIcon,
  CIRCLE_SOLID: "circle-solid",
  APPLICATION_CV_SOLID: "application-cv-solid",
  OTHER_FILES_SOLID: "other-files-solid",
  RAISE_SOLID: "raise-solid",
  CLOCK_SOLID: "clock-solid",
  COPY_SOLID: "copy-solid",
  CV_SOLID: "cv-solid",
  DESCRIPTION_SOLID: "description-solid",
  PREVIEW_SOLID: "preview-solid",
  SEARCH_SOLID: "search-solid",
  TERMINATE_SOLID: "terminate-solid",
  EXPAND_SOLID: "expand-solid",
  JOB_OFFER_TYPE_PREMIUM_SOLID: "job-offer-type-premium-solid",
  JOB_OFFER_TYPE_STANDARD_PLUS_OUTLINE: "job-offer-type-standard-plus-outline",
  JOB_OFFER_TYPE_PRO_SOLID: "job-offer-type-premium-solid",
  LANGUAGES_SOLID: "languages-solid",
  LAYOUT_SOLID: "layout-solid",
  LOGOUT_OUTLINE: "logout-outline",
  COLLAPSE_SOLID: "collapse-solid",
  DOWNLOAD_SOLID: "download-solid",
  PRINT_SOLID: "print-solid",
  PHONE_SOLID: "phone-solid",
  POSITION_SOLID: "position-solid",
  STATUS_CONSIDERED_SOLID: "status-considered-solid",
  STATUS_DECLINED_SOLID: "status-declined-solid",
  STATUS_ACCEPTED_SOLID: "status-accepted-solid",
  PROFILE_SOLID: "profile-solid",
  RECOMMENDED_STAR_SOLID: "recommended-star-solid",
  REMOTE_WORK_SOLID: "remote-work-solid",
  SURNAME_SOLID: "surname-solid",
  TRASH_BIN_SOLID: "trash-bin-solid",
  WARNING_OUTLINE: "warning-outline",
  WORK_LOCATIONS_SOLID: "work-locations-solid",
  ADD_PHOTO_OUTLINE: "add-photo-outline",
  BRIEFCASE_OUTLINE: "briefcase-outline",
  CONTRACT_SOLID: "contract-solid",
  PAPER_PLANE_SOLID: "paper-plane-solid",
};
